import React, { useEffect, useState } from "react";
import {
  server_post_data,
  maintainance_car_data,
  upload_image_to_folder,
} from "../../ServiceConnection/serviceconnection";
import { handleError } from "../../CommonJquery/CommonJquery";
import { X } from "lucide-react";

const FluidsCheck = ({
  onNext,
  onBack,
  MaintainanceData,
  setCount,
  BookingData,
  ImageLink,
  cardata,
  FromComeData,
}) => {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [fluidData, setFluidData] = useState({
    brakeFluid: "",
    coolant: "",
    windshieldWasher: "",
    gas_cap_img: null,
    gas_cap_img_name: "",
  });

  // New state to track sub-values of each fluid
  const [subValues, setSubValues] = useState({
    brakeFluid: "",
    coolant: "",
    windshieldWasher: "",
  });

  //console.log("subValues Data:", subValues);
  const [errorMessages, setErrorMessages] = useState({
    brakeFluid: "",
    coolant: "",
    windshieldWasher: "",
    gas_cap_img: "",
  });

  const handleSelect = (fluidType, value) => {
    setFluidData((prevData) => ({
      ...prevData,
      [fluidType]: value,
    }));

    // Only clear sub-value if not selecting "Top"
    if (value !== "Top~@~2/4") {
      setSubValues((prevSub) => ({
        ...prevSub,
        [fluidType]: "",
      }));
    }

    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      [fluidType]: "",
    }));
  };

  const handleSubValueSelect = (fluidType, value) => {
    setSubValues((prev) => ({
      ...prev,
      [fluidType]: value,
    }));

    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      [fluidType]: "",
    }));
  };
  // console.log(MaintainanceData);
  useEffect(() => {
    setFluidData({
      brakeFluid:
        MaintainanceData.break_fluid && MaintainanceData.break_fluid_value
          ? MaintainanceData.break_fluid +
            "~@~" +
            MaintainanceData.break_fluid_value
          : "",

      coolant:
        MaintainanceData.coolant_fluid && MaintainanceData.coolant_fluid_value
          ? MaintainanceData.coolant_fluid +
            "~@~" +
            MaintainanceData.coolant_fluid_value
          : "",

      windshieldWasher:
        MaintainanceData.windshield_washer &&
        MaintainanceData.windshield_washer_value
          ? MaintainanceData.windshield_washer +
            "~@~" +
            MaintainanceData.windshield_washer_value
          : "",

      gas_cap_img_name: MaintainanceData.check_gas_cap || "",
      gas_cap_img: null,
    });

    // Optionally reset subValues on load
    setSubValues({
      brakeFluid: MaintainanceData.break_fluid_value || "",
      coolant: MaintainanceData.coolant_fluid_value || "",
      windshieldWasher: MaintainanceData.windshield_washer_value || "",
    });
  }, [MaintainanceData]);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      uploadImageserver(file);
    }
  };

  const uploadImageserver = async (file) => {
    const fd = new FormData();
    fd.append("image", file);
    await server_post_data(upload_image_to_folder, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setFluidData((prevData) => ({
            ...prevData,
            gas_cap_img: file,
            gas_cap_img_name: Response.data.message.image_uploaded,
          }));
          setErrorMessages((prevErrors) => ({
            ...prevErrors,
            gas_cap_img: "",
          }));
        }
      })
      .catch((error) => {});
  };

  const removeImage = () => {
    setFluidData((prevData) => ({
      ...prevData,
      gas_cap_img: null,
      gas_cap_img_name: "",
    }));
    setErrorMessages((prevErrors) => ({
      ...prevErrors,
      gas_cap_img: "",
    }));
    document.getElementById("imageInput_gas_cap").value = "";
  };

  const handleNext = async () => {
    let valid = true;

    if (!fluidData.gas_cap_img && fluidData.gas_cap_img_name === "") {
      setErrorMessages((prev) => ({
        ...prev,
        gas_cap_img: "Please upload a gas cap image",
      }));
      valid = false;
    }

    // Brake Fluid
    if (!fluidData.brakeFluid) {
      setErrorMessages((prev) => ({
        ...prev,
        brakeFluid: "Please fill this field",
      }));
      valid = false;
    } else if (fluidData.brakeFluid === "Top~@~2/4" && !subValues.brakeFluid) {
      setErrorMessages((prev) => ({
        ...prev,
        brakeFluid: "Please select a brake fluid sub-level",
      }));
      valid = false;
    }

    // Coolant
    if (!fluidData.coolant) {
      setErrorMessages((prev) => ({
        ...prev,
        coolant: "Please fill this field",
      }));
      valid = false;
    } else if (fluidData.coolant === "Top~@~2/4" && !subValues.coolant) {
      setErrorMessages((prev) => ({
        ...prev,
        coolant: "Please select a coolant sub-level",
      }));
      valid = false;
    }

    // Windshield Washer
    if (!fluidData.windshieldWasher) {
      setErrorMessages((prev) => ({
        ...prev,
        windshieldWasher: "Please fill this field",
      }));
      valid = false;
    } else if (
      fluidData.windshieldWasher === "Top~@~2/4" &&
      !subValues.windshieldWasher
    ) {
      setErrorMessages((prev) => ({
        ...prev,
        windshieldWasher: "Please select a windshield washer sub-level",
      }));
      valid = false;
    }

    if (valid) {
      setshowLoaderAdmin(true);
      //console.log("Selected Fluids:");

      //console.log("Gas Cap Image Name:", fluidData.gas_cap_img_name);

      const fd = new FormData();
      fd.append("car_id", cardata.primary_id);
      fd.append("booking_id", cardata.current_booking_id);
      fd.append("user_id", BookingData?.user_id || 0);
      let brakeFluid = fluidData.brakeFluid.split("~@~");
      let coolant = fluidData.coolant.split("~@~");
      let windshieldWasher = fluidData.windshieldWasher.split("~@~");
      fd.append("break_fluid", brakeFluid[0]);
      fd.append("coolant_fluid", coolant[0]);
      fd.append("windshield_washer", windshieldWasher[0]);
      fd.append("step_for_maintenance", 4);
      fd.append("check_gas_cap", fluidData.gas_cap_img_name);
      // Append sub-values too
      fd.append("break_fluid_value", brakeFluid[1]);
      fd.append("coolant_fluid_value", coolant[1]);
      fd.append("windshield_washer_value", windshieldWasher[1]);
      fd.append("edit_or_new", MaintainanceData?.primary_id || 0);
      fd.append("save_or_edit_type", FromComeData);
      await server_post_data(maintainance_car_data, fd)
        .then((Response) => {
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            onNext();
            setCount(5);
          }
          setshowLoaderAdmin(false);
        })
        .catch((error) => {
          handleError("network");
          setshowLoaderAdmin(false);
        });
    }
  };

  return (
    <>
      <div className="fluids-check-container">
        {/* Brake Fluid Section */}
        <div className="section">
          <h3 className="section-title text-primary">
            Brake Fluid <span className="mandory_field">*</span>
          </h3>
          {errorMessages.brakeFluid && (
            <p className="error-text2">{errorMessages.brakeFluid}</p>
          )}
          <div className="row">
            <div className="col-md-4 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  fluidData.brakeFluid === "Good~@~1/4"
                    ? "active goodActive"
                    : ""
                }`}
                onClick={() => handleSelect("brakeFluid", "Good~@~1/4")}
              >
                Good
              </button>
            </div>
            <div className="col-md-4 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  fluidData.brakeFluid === "Top~@~2/4"
                    ? "active needBulbActive"
                    : ""
                }`}
                onClick={() => handleSelect("brakeFluid", "Top~@~2/4")}
              >
                Top-up
              </button>
            </div>
            <div className="col-md-4 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  fluidData.brakeFluid === "Filed~@~3/4"
                    ? "active needRepairActive"
                    : ""
                }`}
                onClick={() => handleSelect("brakeFluid", "Filed~@~3/4")}
              >
                Filled
              </button>
            </div>
          </div>
          {/* Show sub-values only if 'Top' is selected */}
          {fluidData.brakeFluid === "Top~@~2/4" && (
            <div className="row mt-2">
              {["1/4", "2/4", "3/4"].map((subVal) => (
                <div className="col-md-4 mb-2" key={subVal}>
                  <button
                    className={`btn btn-outline-secondary w-100 ${
                      subValues.brakeFluid === subVal ? "active" : ""
                    }`}
                    onClick={() => handleSubValueSelect("brakeFluid", subVal)}
                  >
                    {subVal}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Coolant Section */}
        <div className="section">
          <h3 className="section-title text-primary">
            Coolant <span className="mandory_field">*</span>
          </h3>
          {errorMessages.coolant && (
            <p className="error-text2">{errorMessages.coolant}</p>
          )}
          <div className="row">
            <div className="col-md-4 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  fluidData.coolant === "Good~@~1/4" ? "active goodActive" : ""
                }`}
                onClick={() => handleSelect("coolant", "Good~@~1/4")}
              >
                Good
              </button>
            </div>
            <div className="col-md-4 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  fluidData.coolant === "Top~@~2/4"
                    ? "active needBulbActive"
                    : ""
                }`}
                onClick={() => handleSelect("coolant", "Top~@~2/4")}
              >
                Top-up
              </button>
            </div>
            <div className="col-md-4 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  fluidData.coolant === "Filed~@~3/4"
                    ? "active needRepairActive"
                    : ""
                }`}
                onClick={() => handleSelect("coolant", "Filed~@~3/4")}
              >
                Filled
              </button>
            </div>
          </div>
          {fluidData.coolant === "Top~@~2/4" && (
            <div className="row mt-2">
              {["1/4", "2/4", "3/4"].map((subVal) => (
                <div className="col-md-4 mb-2" key={subVal}>
                  <button
                    className={`btn btn-outline-secondary w-100 ${
                      subValues.coolant === subVal ? "active" : ""
                    }`}
                    onClick={() => handleSubValueSelect("coolant", subVal)}
                  >
                    {subVal}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Windshield Washer Section */}
        <div className="section">
          <h3 className="section-title text-primary">
            Windshield Washer <span className="mandory_field">*</span>
          </h3>
          {errorMessages.windshieldWasher && (
            <p className="error-text2">{errorMessages.windshieldWasher}</p>
          )}
          <div className="row">
            <div className="col-md-4 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  fluidData.windshieldWasher === "Good~@~1/4"
                    ? "active goodActive"
                    : ""
                }`}
                onClick={() => handleSelect("windshieldWasher", "Good~@~1/4")}
              >
                Good
              </button>
            </div>
            <div className="col-md-4 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  fluidData.windshieldWasher === "Top~@~2/4"
                    ? "active needBulbActive"
                    : ""
                }`}
                onClick={() => handleSelect("windshieldWasher", "Top~@~2/4")}
              >
                Top-up
              </button>
            </div>
            {/* <div className="col-md-4 mb-2">
              <button
                className={`btn btn-outline-secondary w-100 ${
                  fluidData.windshieldWasher === "Filed~@~3/4"
                    ? "active needRepairActive"
                    : ""
                }`}
                onClick={() => handleSelect("windshieldWasher", "Filed~@~3/4")}
              >
                Filled
              </button>
            </div> */}
          </div>
          {fluidData.windshieldWasher === "Top~@~2/4" && (
            <div className="row mt-2">
              {["1/4", "2/4", "3/4"].map((subVal) => (
                <div className="col-md-4 mb-2" key={subVal}>
                  <button
                    className={`btn btn-outline-secondary w-100 ${
                      subValues.windshieldWasher === subVal ? "active" : ""
                    }`}
                    onClick={() =>
                      handleSubValueSelect("windshieldWasher", subVal)
                    }
                  >
                    {subVal}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Gas Cap Image Section */}
        <div className="section">
          <h3 className="section-title text-primary">
            Check Gas Cap <span className="mandory_field">*</span>
          </h3>
          {errorMessages.gas_cap_img && (
            <p className="error-text2">{errorMessages.gas_cap_img}</p>
          )}
          <div className="col-md-6">
            <input
              id="imageInput_gas_cap"
              type="file"
              className="form-control custmInput"
              onChange={handleImageUpload}
              accept=".png, .jpeg, .jpg, .heic"
            />
            {fluidData.gas_cap_img_name && (
              <div className="oil_close_cap_div">
                <img
                  src={ImageLink + fluidData.gas_cap_img_name}
                  alt="Gas Cap Image Preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                />
                <X className="removeBttn" size={18} onClick={removeImage} />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="navigation-buttons">
        <button className="btn back-button" onClick={onBack}>
          Back
        </button>

        <button className="btn next__button" onClick={handleNext}>
          Next
        </button>
      </div>
    </>
  );
};

export default FluidsCheck;
